import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../styles/header.css';

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <header id="header" className={`header d-flex align-items-center fixed-top ${scrolled ? 'scrolled' : ''}`}>
        <div className="container-fluid container-xl d-flex align-items-center">

          <Link to="/" className="logo d-flex align-items-center" style={{ flex: 1 }}>
            <div className="logo-badge">
              <img src="/img/aprilgroups-logo.jpeg" alt="April Groups Logo" className="img-fluid logo-img" />
            </div>
          </Link>

          {/* Desktop nav */}
          <nav id="navmenu" className="navmenu d-none d-xl-flex">
            <ul>
              <li><Link to="/" className={location.pathname === '/' ? 'active' : ''}>Home</Link></li>
              
              <li>
                <a href="#about">About</a>
                <div className="nav-popover">
                  <div className="nav-popover-title">Trading & Installation</div>
                  <p className="nav-popover-content">
                    Complete fire protection trading and installation services with certified products, expert execution, and long-term reliability.
                  </p>
                </div>
              </li>

              <li>
                <a href="#services">Services</a>
                <div className="nav-popover">
                  <div className="nav-popover-title">Our Products</div>
                  <ul className="nav-popover-list">
                    <li><i className="bi bi-check2-circle"></i> Fire Alarm Systems</li>
                    <li><i className="bi bi-check2-circle"></i> Wireless Fire Alarms</li>
                    <li><i className="bi bi-check2-circle"></i> Emergency Light Systems</li>
                    <li><i className="bi bi-check2-circle"></i> Fire Cables</li>
                    <li><i className="bi bi-check2-circle"></i> Valves</li>
                    <li><i className="bi bi-check2-circle"></i> Sprinklers</li>
                    <li><i className="bi bi-check2-circle"></i> Foam Systems</li>
                    <li><i className="bi bi-check2-circle"></i> FM200 Systems</li>
                    <li><i className="bi bi-check2-circle"></i> Pre Action Systems</li>
                  </ul>
                </div>
              </li>

              <li>
                <a href="#portfolio">Portfolio</a>
                <div className="nav-popover text-center" style={{ minWidth: '130px', padding: '0.75rem 1rem' }}>
                  <div style={{ fontSize: '0.85rem', color: '#666', fontWeight: '600' }}>
                    <i className="bi bi-hourglass-split me-1"></i>Loading...
                  </div>
                </div>
              </li>
              <li>
                <a href="#team">Team</a>
                <div className="nav-popover text-center" style={{ minWidth: '130px', padding: '0.75rem 1rem' }}>
                  <div style={{ fontSize: '0.85rem', color: '#666', fontWeight: '600' }}>
                    <i className="bi bi-hourglass-split me-1"></i>Loading...
                  </div>
                </div>
              </li>

              <li>
                <Link to="/contact">Contact</Link>
                <div className="nav-popover">
                  <div className="nav-popover-title">Trading Contact</div>
                  <div className="nav-contact-info">
                    <div className="nav-contact-row">
                      <span><i className="bi bi-telephone me-2 text-danger"></i><strong>Phone:</strong></span>
                      <span className="nav-contact-values">
                        <span>+97 1562 702486</span>
                        <span>+97 1565 508883</span>
                      </span>
                    </div>
                    <div className="nav-contact-row">
                      <span><i className="bi bi-envelope me-2 text-danger"></i><strong>Email:</strong></span>
                      <span className="nav-contact-values">
                        <span>hirshad@aprilgroups.com</span>
                        <span>nana@aprilpumps.com</span>
                      </span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </nav>

          {/* Hamburger toggle (mobile only - on the right) */}
          <button
            className="mobile-nav-toggle d-xl-none"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle navigation"
          >
            <i className={`bi ${mobileOpen ? 'bi-x' : 'bi-list'}`}></i>
          </button>

          {/* <Link className="cta-btn btn-getstarted" to="/contact">Get Started</Link> */}

        </div>
      </header>

      {/* Mobile dropdown — outside header so backdrop-filter doesn't clip it */}
      {mobileOpen && (
        <div className="mobile-nav-menu">
          <ul>
            <li><Link to="/" onClick={() => setMobileOpen(false)}>Home</Link></li>
            <li><a href="#about" onClick={() => setMobileOpen(false)}>About</a></li>
            <li><a href="#services" onClick={() => setMobileOpen(false)}>Services</a></li>
            <li><a href="#portfolio" onClick={() => setMobileOpen(false)}>Portfolio</a></li>
            <li><a href="#team" onClick={() => setMobileOpen(false)}>Team</a></li>
            <li><Link to="/contact" onClick={() => setMobileOpen(false)}>Contact</Link></li>
          </ul>
        </div>
      )}
    </>
  );
};

export default Header;